import React from "react";

import { useMutation, useQueryClient } from "@tanstack/react-query";

import { BannerForm } from "pages/main/BannerManager/BannerForm";
import { createBanner } from "shared/api/BannerApi";

// 등록 폼 초기값(빈 값). 모듈 상수로 둬 BannerForm이 1회만 초기화하도록 안정 참조 유지.
const EMPTY_INITIAL = {
  title: "",
  hide: true, // true=미게시 기본값
  start: "",
  end: "",
  imagePc: "",
  imageMob: "",
};

function BannerRegister() {
  const queryClient = useQueryClient();
  const createBannerMutation = useMutation({
    mutationFn: createBanner,
    onSuccess: (createdBanner) => {
      queryClient.setQueryData(["banners"], (previous = []) => [
        {
          ...createdBanner,
          webImage:
            createdBanner.webImage ||
            createdBanner.imageUrl ||
            createdBanner.image ||
            "",
        },
        ...previous,
      ]);
    },
  });

  return (
    <BannerForm
      mode="create"
      initialValues={EMPTY_INITIAL}
      onSubmit={(data) => createBannerMutation.mutateAsync(data)}
    />
  );
}

export default BannerRegister;
